import SelectParkingSpotsModal from "./selectParkingSpotsModal";

export default SelectParkingSpotsModal;